module.exports = __webpack_public_path__ + "static/media/whatsapp.2b83c1a9.svg";